import { accountBadgeEntityName, accountBadgeFrontImageAttachmentKey } from '../../../../../backend/features/badges/shared';
import { useAccountBadgeActions } from '../../../../../ui/features/badge-management/hooks/useAccountBadgeActions';
import { stopEventPropagation } from '../../../../../ui/features/badge-management/utils/stopEventPropagationHandler';
import { showAccountBadgePreviewModal } from '../../../../../ui/features/badge-preview/utils/showAccountBadgePreviewModal';
import { showContactUsModal } from '../../../../../ui/features/badge-preview/utils/showContactUsModal';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import BlockIcon from '@mui/icons-material/Block';
import ChevronRightIconOutlined from '@mui/icons-material/ChevronRightOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, Button, Card, Divider, IconButton, Typography } from '@mui/material';
import React from 'react';
const htmlEmptySpace = '\u00A0';
export const AccountBadgeUserViewTableRow = (props) => {
    var _a, _b;
    const { t } = useBadgingTranslation();
    const actions = useAccountBadgeActions({
        accountBadge: props.row,
        onActionSuccess: props.onActionSuccess,
    });
    const handlePreviewBadgeImage = () => {
        showAccountBadgePreviewModal(props.row);
    };
    const handleContactUs = () => {
        showContactUsModal(t);
    };
    const handleRowClick = () => {
        var _a;
        (_a = props.onRowClick) === null || _a === void 0 ? void 0 : _a.call(props, props.row);
    };
    return (React.createElement(Card, { sx: Object.assign({ borderLeft: `8px solid ${props.row.columns.isStatusValid ? themeColors.accent.green.base : themeColors.accent.red.base}`, width: '100%', minHeight: 80, maxHeight: 88, px: 2, py: 2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: { xs: 1, sm: 3 }, ':hover': { backgroundColor: themeColors.surface.hover }, cursor: props.onRowClick ? 'pointer' : 'auto', overflow: 'auto' }, props.sx), onClick: handleRowClick },
        React.createElement(Box, { sx: {
                height: '100%',
                maxHeight: 88,
                minWidth: 80,
                width: 88,
                borderColor: themeColors.border.main,
                borderWidth: 1,
                borderStyle: 'solid',
                borderRadius: 1,
                overflow: 'hidden',
                aspectRatio: '172/112',
            } },
            React.createElement(Image, { entity: accountBadgeEntityName, entityId: props.row.id, attachmentKey: accountBadgeFrontImageAttachmentKey, sx: { width: '100%' } })),
        React.createElement(Box, { sx: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'start',
            } },
            React.createElement(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                } },
                React.createElement(Typography, { variant: 'h6', noWrap: true, sx: {
                        width: { xs: 180, md: 370, lg: 680, xl: 1000 },
                        flexShrink: 1,
                        flexGrow: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    } }, props.row.columns.badgeName)),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                } },
                React.createElement(Typography, { variant: 'body2', noWrap: true }, (_b = (props.row.columns.organizationId && ((_a = props.organizationMap[props.row.columns.organizationId]) === null || _a === void 0 ? void 0 : _a.columns.name))) !== null && _b !== void 0 ? _b : htmlEmptySpace))),
        React.createElement(Box, { sx: { display: 'flex', gap: 1, flexShrink: 0 } },
            props.row.columns.status === 'valid' && (React.createElement(Button, { startIcon: React.createElement(VisibilityOutlinedIcon, { sx: { width: 18, height: 20 }, color: 'info' }), onClick: stopEventPropagation(handlePreviewBadgeImage) },
                React.createElement(Typography, { variant: 'subtitle2', noWrap: true }, t('badgePreview.preview')))),
            props.row.columns.status === 'valid' && (React.createElement(Button, { variant: 'text', startIcon: React.createElement(BlockIcon, null), disabled: !actions.canRevoke, onClick: stopEventPropagation(actions.handleAccountBadgeRevoke) },
                React.createElement(Typography, { variant: 'subtitle2', noWrap: true }, t('badges.badgeDetails.accountBadgeTable.actions.revoke')))),
            props.row.columns.status !== 'valid' && (React.createElement(Button, { size: 'small', variant: 'text', sx: { height: 24 }, onClick: stopEventPropagation(handleContactUs) },
                React.createElement(Typography, { variant: 'subtitle2', noWrap: true }, t('accountBadgeSection.accountBadgesTable.contactButton')))),
            props.onRowClick && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { orientation: 'vertical', variant: 'middle', flexItem: true, sx: { my: 0, height: 24 } }),
                React.createElement(IconButton, { "aria-label": t('accountBadgeSection.accountBadgesTable.openBadgeButton'), color: 'primary', size: 'small', sx: { height: 24 } },
                    React.createElement(ChevronRightIconOutlined, null)))))));
};
